export function getTypedCRUDErrors(error: any) {
  if (!error || !error.response || !error.response.data) {
    return [];
  }

  if (error.response?.data?.fields) {
    return error.response.data.fields as TypedCRUDError[];
  }

  if (error?.response?.data) {
    return [
      {
        message: error.response.data,
      },
    ] as TypedCRUDError[];
  }
}
